import React, { useEffect } from 'react';
import { Switch, Route } from 'react-router-dom';
import UI from './routes/UI';
import Landing from './routes/Landing';
import Auth from './routes/Auth';
import Dashboard from './routes/Dashboard';
import { useSelector } from 'react-redux';
import { Hub } from 'aws-amplify';
import { useDispatch } from 'react-redux';
import { checkAuthState, onAuthStateChange } from './actions/authActions';
import { LastLocationProvider } from 'react-router-last-location';
import { useHistory } from 'react-router';
import Loading from 'shared/components/Loading';
import Contact from './routes/Landing/routes/Contact';
import Privacy from './routes/Landing/routes/Privacy';
import Terms from './routes/Landing/routes/Terms';
import Imprint from './routes/Landing/routes/Imprint';
import WhyLikiee from './routes/Landing/routes/WhyLikiee';
import HowItWorks from './routes/Landing/routes/HowItWorks';
import FAQ from './routes/Landing/routes/FAQ';
import Support from './routes/Landing/routes/Support';
import Onboarding from './routes/Landing/routes/Onboarding';
import Cookie from './routes/Landing/routes/Cookie';
import VirtualTryOnPage from './routes/Landing/routes/VirtualTryOnPage';
// import AIComparisonPage from './routes/Landing/routes/AIComparisonPage';
import PriceTrackingPage from './routes/Landing/routes/PriceTrackingPage';
import SharedWishlistsPage from './routes/Landing/routes/SharedWishlistsPage';
import LookBuilder from './routes/Landing/pages/LookBuilder';
import ScrollToTop from 'shared/components/ScrollToTop';
import LanguageRouter from 'shared/components/LanguageRouter';

const App = () => {
  const history = useHistory();
  const isAuth = useSelector(state => state.isAuthenticated);
  const dispatch = useDispatch();

  useEffect(() => {
    Hub.listen('auth', e => dispatch(onAuthStateChange(e, history)));
    dispatch(checkAuthState());
    setInterval(() => {
      document.querySelector('iframe')?.remove();
    }, 1000);
  }, []);

  if (isAuth === null) return <Loading className='min-vh-100' />;

  return (
    <LastLocationProvider>
      <ScrollToTop />
      <Switch>
        {/* Routes with language prefix (only for non-English languages like /de/) */}
        <Route path='/:lang(de)'>
          <LanguageRouter>
            <Switch>
              {!isAuth && <Route path='/:lang/auth' component={Auth} />}
              <Route path='/:lang/ui' component={UI} />
              <Route path='/:lang/contact' component={Contact} />
              <Route path='/:lang/terms' component={Terms} />
              <Route path='/:lang/policy' component={Privacy} />
              <Route path='/:lang/cookie' component={Cookie} />
              <Route path='/:lang/imprint' component={Imprint} />
              <Route path='/:lang/why' component={WhyLikiee} />
              <Route path='/:lang/how' component={HowItWorks} />
              <Route path='/:lang/support' component={Support} />
              <Route path='/:lang/faq' component={FAQ} />
              <Route path='/:lang/onboarding' component={Onboarding} />
              <Route path='/:lang/virtual-try-on' component={VirtualTryOnPage} />
              <Route path='/:lang/price-tracking' component={PriceTrackingPage} />
              <Route path='/:lang/shared-wishlists' component={SharedWishlistsPage} />
              <Route path='/:lang/look-builder' component={LookBuilder} />
              <Route exact path='/:lang' component={Landing} />
              {isAuth && <Route path='/:lang/' component={Dashboard} />}
            </Switch>
          </LanguageRouter>
        </Route>

        {/* Default routes without language prefix (English) */}
        <LanguageRouter>
          <Switch>
            {!isAuth && <Route path='/auth' component={Auth} />}
            <Route path='/ui' component={UI} />
            <Route path='/contact' component={Contact} />
            <Route path='/terms' component={Terms} />
            <Route path='/policy' component={Privacy} />
            <Route path='/cookie' component={Cookie} />
            <Route path='/imprint' component={Imprint} />
            <Route path='/why' component={WhyLikiee} />
            <Route path='/how' component={HowItWorks} />
            <Route path='/support' component={Support} />
            <Route path='/faq' component={FAQ} />
            <Route path='/onboarding' component={Onboarding} />
            <Route path='/virtual-try-on' component={VirtualTryOnPage} />
            <Route path='/price-tracking' component={PriceTrackingPage} />
            <Route path='/shared-wishlists' component={SharedWishlistsPage} />
            <Route path='/look-builder' component={LookBuilder} />
            <Route exact path='/' component={Landing} />
            {isAuth && <Route path='/' component={Dashboard} />}
          </Switch>
        </LanguageRouter>
      </Switch>
    </LastLocationProvider>
  );
};

export default App;
